import {apiRequest} from './client';
import type {ApiToken, ApiTokenActivityPage, CreateApiTokenRequest, CreateApiTokenResponse, McpConnectionTestResult} from '@/types/api';

export async function getApiTokens(): Promise<ApiToken[]> {
    return apiRequest<ApiToken[]>('/tokens', {
        method: 'GET'
    });
}

export async function createApiToken(data: CreateApiTokenRequest): Promise<CreateApiTokenResponse> {
    return apiRequest<CreateApiTokenResponse>('/tokens', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export async function revokeApiToken(id: string): Promise<{ message: string }> {
    return apiRequest<{ message: string }>(`/tokens/${id}/revoke`, {
        method: 'POST'
    });
}

export async function getApiTokenActivity(id: string, before?: string): Promise<ApiTokenActivityPage> {
    const query = before ? `?before=${encodeURIComponent(before)}` : '';
    return apiRequest<ApiTokenActivityPage>(`/tokens/${encodeURIComponent(id)}/activity${query}`, {method: 'GET'});
}

export async function testApiTokenConnection(id: string, token: string): Promise<McpConnectionTestResult> {
    return apiRequest<McpConnectionTestResult>(`/tokens/${encodeURIComponent(id)}/test`, {
        method: 'POST',
        body: JSON.stringify({token})
    });
}
